module.exports = require('./lib/websocket');


//////////////////
// WEBPACK FOOTER
// ./~/web3/~/websocket/index.js
// module id = 1994
// module chunks = 0 1 3